import { z } from 'zod';
import { route, defineContract } from '../core/types';
import { requiredStringSchema, coerceBooleanFromString } from '../schemas';

// ============================================================
// Param Schemas
// ============================================================

const projectParamsSchema = z.object({
	projectId: requiredStringSchema,
});

// ============================================================
// Contract
// ============================================================

export const unassignedActivityContract = defineContract(
	'unassigned',
	{
		/**
		 * A filtered collection, not a nested resource: the profession narrows the
		 * list, it does not own it. `/byProfessionId/:professionId` was the
		 * nested-resource costume the migration playbook warns about — and it took
		 * its project from the `project-id` HEADER, which every authenticated
		 * request carries, so the route asserted nothing about which project it was
		 * reading.
		 */
		getUnassignedActivitiesByProfession: route({
			method: 'GET',
			path: '/projects/:projectId/unassignedActivities',
			params: projectParamsSchema,
			query: z.object({
				professionId: requiredStringSchema,
				includeVisibleTags: coerceBooleanFromString.optional(),
			}),
			response: z.array(z.any()),
			operationId: 'getUnassignedActivitiesByProfessionId',
			tags: ['Unassigned Activities'],
			summary: 'List the unassigned activities of a project, filtered by profession',
		}),
	},
	{ root: true }
);
